<template>
  <div class="independent-wrapper">
    <div class="content">
      <div class="title">
        <span class="border"></span>
        <i class="el-icon-location-outline"></i> 商城管理 > 会员充值
      </div>
      <div class="contentLeft">
        <div class="con">
          <!-- 顶部筛选 + 新增 -->
          <div class="toolbar">
            <el-input v-model="query.phone" placeholder="会员手机号" clearable style="width: 160px; margin-right: 10px;" @keyup.enter="handleSearch"></el-input>
            <el-input v-model="query.name" placeholder="会员姓名" clearable style="width: 140px; margin-right: 10px;" @keyup.enter="handleSearch"></el-input>
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="YYYY-MM-DD"
              style="margin-right: 10px;"
              @change="handleSearch"
            ></el-date-picker>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button type="success" @click="openCreate" style="margin-left: 10px;">新增充值</el-button>
          </div>

          <!-- 表格 -->
          <div class="table-con consiliaTable">
            <el-table
              :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
              tooltip-effect="dark"
              style="width: 100%"
              :data="tableData"
              v-loading="loading"
            >
              <el-table-column align="center" label="充值单号" prop="rechargeNo" min-width="200"></el-table-column>
              <el-table-column align="center" label="会员" width="140">
                <template #default="{ row }">
                  <div>{{ row.memberName || '-' }}</div>
                  <div style="font-size: 12px; color: #999;">{{ row.memberPhone }}</div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="角色" width="100">
                <template #default="{ row }">
                  <el-tag :type="roleTagType(row.memberRole)" size="small">{{ row.memberRoleName || '-' }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" label="金额" width="110">
                <template #default="{ row }">
                  <span style="color: #67c23a; font-weight: bold;">¥{{ formatPrice(row.amount) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="凭证" width="100">
                <template #default="{ row }">
                  <span v-if="row.voucherUrl" class="editor" @click="previewVoucher(row)">{{ row.voucherType === 'pdf' ? '查看PDF' : '查看图片' }}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="备注" prop="remark" min-width="160" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="操作员" prop="operatorName" width="110"></el-table-column>
              <el-table-column align="center" label="时间" width="160">
                <template #default="{ row }">{{ formatTime(row.createTime) }}</template>
              </el-table-column>
            </el-table>

            <div class="pagination-wrap">
              <el-pagination
                background
                layout="total, prev, pager, next"
                :total="total"
                :current-page="query.pageNum"
                :page-size="query.pageSize"
                @current-change="handlePageChange"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增充值弹窗 -->
    <el-dialog v-model="createVisible" title="新增充值" width="520px" :close-on-click-modal="false" class="recharge-dialog">
      <el-form :model="form" label-width="90px" ref="formRef">
        <el-form-item label="会员" required>
          <el-select
            v-model="form.memberId"
            filterable
            remote
            reserve-keyword
            placeholder="输入手机号或姓名搜索"
            :remote-method="searchMember"
            :loading="memberSearchLoading"
            style="width: 100%"
          >
            <el-option
              v-for="m in memberOptions"
              :key="m.id"
              :label="`${m.name || '-'}  ${m.phone || ''}  ${m.roleName || ''}`"
              :value="m.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="金额" required>
          <el-input-number v-model="form.amount" :min="0.01" :step="100" :precision="2" style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="凭证" required>
          <el-upload
            :action="uploadUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :before-upload="beforeUpload"
            :on-success="onUploadSuccess"
            :on-error="onUploadError"
            accept=".jpg,.jpeg,.png,.gif,.pdf"
          >
            <el-button type="primary">选择文件（图片或PDF）</el-button>
          </el-upload>
          <div v-if="form.voucherUrl" style="margin-top: 8px;">
            <span v-if="form.voucherType === 'pdf'">
              已上传 PDF：<a :href="resolveUrl(form.voucherUrl)" target="_blank">{{ form.voucherUrl.split('/').pop() }}</a>
            </span>
            <img v-else :src="resolveUrl(form.voucherUrl)" alt="凭证" style="max-width: 200px; max-height: 200px; border: 1px solid #eee;" />
          </div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="createVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitCreate">确认充值</el-button>
      </template>
    </el-dialog>

    <!-- 凭证预览 -->
    <el-dialog v-model="previewVisible" title="凭证预览" width="640px">
      <div v-if="previewItem">
        <div v-if="previewItem.voucherType === 'pdf'">
          <iframe :src="resolveUrl(previewItem.voucherUrl)" style="width: 100%; height: 560px; border: 1px solid #eee;"></iframe>
        </div>
        <div v-else style="text-align: center;">
          <img :src="resolveUrl(previewItem.voucherUrl)" style="max-width: 100%; max-height: 560px;" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axiosconf from '../../api/axiosconf'
import global from '../../globle/globle'
import store from '../../store'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      dateRange: [],
      query: {
        pageNum: 1,
        pageSize: 10,
        phone: '',
        name: '',
      },

      createVisible: false,
      submitting: false,
      memberSearchLoading: false,
      memberOptions: [],
      memberSearchTimer: null,
      form: {
        memberId: null,
        amount: null,
        voucherUrl: '',
        voucherType: '',
        remark: '',
      },

      previewVisible: false,
      previewItem: null,
    }
  },
  computed: {
    uploadUrl() {
      return global.axiosDefaultsURL + 'mall/admin/recharge/upload-voucher'
    },
    uploadHeaders() {
      return { token: store.getters.tokenString }
    },
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    formatPrice(val) {
      if (val === null || val === undefined) return '0.00'
      return parseFloat(val).toFixed(2)
    },
    formatTime(val) {
      if (!val) return '-'
      if (typeof val === 'string') return val
      return new Date(val).toLocaleString('zh-CN', { hour12: false })
    },
    roleTagType(role) {
      // 1=普通会员/经销商/区代/城代 → 直接按 code 给色
      const map = { 1: '', 2: 'info', 3: 'warning', 4: 'success' }
      return map[role] || ''
    },
    handleSearch() {
      this.query.pageNum = 1
      this.fetchList()
    },
    async fetchList() {
      this.loading = true
      try {
        const params = {
          pageNum: this.query.pageNum,
          pageSize: this.query.pageSize,
        }
        if (this.query.phone) params.phone = this.query.phone
        if (this.query.name) params.name = this.query.name
        if (this.dateRange && this.dateRange.length === 2) {
          params.startTime = this.dateRange[0] + ' 00:00:00'
          params.endTime = this.dateRange[1] + ' 23:59:59'
        }
        const res = await axiosconf.applicationJson('/mall/admin/recharge/list', params)
        if (res.data && res.data.code === 0) {
          this.tableData = res.data.data.records || []
          this.total = res.data.data.total || 0
        } else {
          this.$message.error((res.data && res.data.msg) || '查询失败')
        }
      } catch (e) {
        console.error('获取充值记录失败', e)
        this.$message.error('查询失败')
      } finally {
        this.loading = false
      }
    },
    handlePageChange(page) {
      this.query.pageNum = page
      this.fetchList()
    },

    openCreate() {
      this.form = { memberId: null, amount: null, voucherUrl: '', voucherType: '', remark: '' }
      this.memberOptions = []
      this.createVisible = true
    },

    searchMember(keyword) {
      if (this.memberSearchTimer) clearTimeout(this.memberSearchTimer)
      const kw = (keyword || '').trim()
      if (!kw) {
        this.memberOptions = []
        return
      }
      this.memberSearchTimer = setTimeout(async () => {
        this.memberSearchLoading = true
        try {
          const res = await axiosconf.applicationJson('/mall/admin/recharge/member-search', { keyword: kw })
          if (res.data && res.data.code === 0) {
            const list = res.data.data || []
            this.memberOptions = list.map(r => ({
              id: r.id,
              name: r.name,
              phone: r.phone,
              roleName: r.roleName || '',
            }))
          }
        } catch (e) {
          console.error('搜索会员失败', e)
        } finally {
          this.memberSearchLoading = false
        }
      }, 300)
    },

    beforeUpload(file) {
      const isPdf = file.type === 'application/pdf'
      const isImage = /^image\/(jpeg|png|gif)$/.test(file.type)
      if (!isPdf && !isImage) {
        this.$message.error('仅支持 JPG/PNG/GIF/PDF')
        return false
      }
      const limit = 10 * 1024 * 1024
      if (file.size > limit) {
        this.$message.error('文件不能超过 10MB')
        return false
      }
      return true
    },
    onUploadSuccess(res) {
      if (res && res.code === 0) {
        this.form.voucherUrl = res.url
        const ext = (res.extension || '').toLowerCase()
        this.form.voucherType = ext === 'pdf' ? 'pdf' : 'image'
        this.$message.success('凭证上传成功')
      } else {
        this.$message.error((res && res.msg) || '凭证上传失败')
      }
    },
    onUploadError() {
      this.$message.error('凭证上传失败')
    },

    async submitCreate() {
      if (!this.form.memberId) return this.$message.warning('请选择会员')
      if (!this.form.amount || this.form.amount <= 0) return this.$message.warning('请输入正确金额')
      if (!this.form.voucherUrl) return this.$message.warning('请上传凭证')
      this.submitting = true
      try {
        const body = {
          memberId: this.form.memberId,
          amount: this.form.amount,
          voucherUrl: this.form.voucherUrl,
          voucherType: this.form.voucherType,
          remark: this.form.remark || '',
        }
        const res = await axiosconf.applicationJson('/mall/admin/recharge/create', body)
        if (res.data && res.data.code === 0) {
          this.$message.success('充值成功')
          this.createVisible = false
          this.fetchList()
        } else {
          this.$message.error((res.data && res.data.msg) || '充值失败')
        }
      } catch (e) {
        console.error('充值失败', e)
        this.$message.error('充值失败')
      } finally {
        this.submitting = false
      }
    },

    previewVoucher(row) {
      this.previewItem = row
      this.previewVisible = true
    },

    resolveUrl(url) {
      if (!url) return ''
      if (/^https?:\/\//.test(url)) return url
      // axiosDefaultsURL 形如 http://localhost:8280/SMY_TONGUE/，url 形如 /profile/...
      // /profile/** 静态映射挂在 contextPath /SMY_TONGUE 下，必须保留前缀
      const base = global.axiosDefaultsURL.replace(/\/$/, '')
      return base + (url.startsWith('/') ? url : '/' + url)
    },
  },
}
</script>

<style scoped>
.independent-wrapper { width: 100%; height: 100%; overflow-y: auto; }
.content { padding: 20px; }
.title { font-size: 14px; color: #333; margin-bottom: 20px; }
.title .border { display: inline-block; width: 3px; height: 14px; background: #679FF6; margin-right: 8px; vertical-align: middle; }
.toolbar { margin-bottom: 16px; display: flex; align-items: center; flex-wrap: wrap; gap: 4px; }
/* 修正全局 .el-input__inner{width:250px} 遗留规则导致 inner 溢出 wrapper、placeholder 被裁切 */
.toolbar :deep(.el-input__inner) { width: 100%; }
.pagination-wrap { margin-top: 16px; text-align: right; }
.editor { color: #409eff; cursor: pointer; }
</style>

<!-- el-dialog 被 teleport 到 body、无 scopeId，scoped/:deep 无法命中；用唯一类名做非 scoped 局部覆盖。
     原生 el-dialog body padding-top=0 使表单贴住标题分割线，补足上下内边距 -->
<style>
.recharge-dialog .el-dialog__body { padding: 20px 24px 4px; }
</style>
